import { createContext } from 'react';

import type { BillingUsage } from '@mio/shared';

/** The shell supplies balances to full-screen editors without a second data request. */
export const UsageContext = createContext<BillingUsage | null>(null);
